import { VehicleRow } from "services/api/catalog/vehicles/types";
import { Column, ColumnTypes } from "ui/components/Table/TableSearch/types";

export const CALCUALTION_VEHICLE_GROUP_VEHICLES_SEARCH_COLUMNS: Column[] = [
  {
    title: "",
    field: "image",
    type: ColumnTypes.custom,
    render: (row: VehicleRow) => {
      return (
        <div>
          {row.model?.image ? (
            <img src={row.model?.image} alt="" className="h-10" />
          ) : (
            <div className="w-10 h-10 rounded-full bg-gray-200 block relative">
              <span className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
                {row.manufacturer?.name?.toString().charAt(0).toUpperCase()}
              </span>
            </div>
          )}
        </div>
      );
    },
  },
  {
    title: "admin.calculation.vehiclegroup.vehicles.manufacturer.name",
    field: "",
    type: ColumnTypes.custom,
    render: (row: VehicleRow) => {
      return (
        <div>
          <div className="text-md">{row.manufacturer?.name} </div>
        </div>
      );
    },
  },
  {
    title: "admin.calculation.vehiclegroup.vehicles.model.name",
    field: "",
    type: ColumnTypes.custom,
    render: (row: VehicleRow) => {
      return (
        <div>
          <div className="text-md">{row.model?.name}</div>
        </div>
      );
    },
  },
  {
    title: "admin.calculation.vehiclegroup.vehicles.type.name",
    field: "",
    type: ColumnTypes.custom,
    render: (row: VehicleRow) => {
      return (
        <div>
          <div className="text-md">{row.type?.name}</div>
        </div>
      );
    },
  },
  {
    title: "admin.calculation.vehiclegroup.vehicles.type.fueltype",
    field: "",
    type: ColumnTypes.custom,
    render: (row) => {
      return (
        <div>
         <div className="text-md">{row.type.fuelType?.name}</div>
        </div>
      );
    },
  },
  {
    title: "admin.calculation.vehiclegroup.vehicles.model.year",
    field: "",
    type: ColumnTypes.custom,
    render: (row) => {
      return (
        <div>
          <div className="text-md">{row.model.year} </div>
        </div>
      );
    },
  },
  {
    title: "admin.calculation.vehiclegroup.vehicles.model.kwhp",
    field: "",
    type: ColumnTypes.custom,
    render: (row) => {
      return (
        <div>
          <div className="text-md">{row.type.maximumPowerKw} KW/{row.type.maximumPowerHp} HP</div>
        </div>
      );
    },
  },
  {
    title: "admin.calculation.vehiclegroup.vehicles.model.transmission",
    field: "",
    type: ColumnTypes.custom,
    render: (row) => {
      return (
        <div>
          <div className="text-md">{row.type.transmission?.name} </div>
        </div>
      );
    },
  },
];

